module.exports = __webpack_public_path__ + "img/caidan.56b9a493.svg";